import dayjs from "dayjs";
import objectSupport from "dayjs/plugin/objectSupport";

dayjs.extend(objectSupport);

// Time and Date checks
// ======================================================

export function timestamp() {
  return dayjs().format();
}

export function stringToDate(dateString) {
  let timeParts = dateString.split(":");
  let date = new Date();
  date.setHours(timeParts[0]);
  date.setMinutes(timeParts[1]);
  return date;
}

export function nowHM() {
  return dateToHHMM(new Date());
}

export function dateToHHMM(date) {
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");

  return `${hours}:${minutes}`;
}

export function isCurrentDate(date, comparisonType = "day") {
  const currentDate = new Date();

  if (comparisonType === "month") {
    return date.getUTCFullYear() === currentDate.getFullYear() && date.getUTCMonth() === currentDate.getMonth();
  }

  if (comparisonType === "day") {
    return (
      date.getUTCFullYear() === currentDate.getFullYear() &&
      date.getUTCMonth() === currentDate.getMonth() &&
      date.getUTCDate() === currentDate.getDate()
    );
  }

  if (comparisonType === "week") {
    const oneDayMilliseconds = 24 * 60 * 60 * 1000;
    const daysDiff = Math.floor((currentDate - date) / oneDayMilliseconds);
    return daysDiff < 7 && daysDiff >= 0;
  }

  return false; // Invalid comparisonType
}

// convert a [string] 00:00 into a JS Date Object
export function dateStringToJS(string) {
  // get the hour part 00:
  // and the mins part :00
  // make a new date Obj with. i can use these to compare.
  let h = string.match(/\d{1,2}/g)[0];
  let m = string.match(/\d{1,2}/g)[1];
  let time = new Date().setHours(h, m);
  return time;
}

export function hhmmStringToJS(string) {
  // get the hour part 00:
  // and the mins part :00
  // make a new date Obj with. i can use these to compare.
  let h = string.match(/\d{1,2}/g)[0];
  let m = string.match(/\d{1,2}/g)[1];
  let dateObj = new Date();
  dateObj.setHours(h, m);

  return dateObj;
}

// From http://stackoverflow.com/questions/6355063/ddg#6355083
export function isLastDay(jsdate) {
  return new Date(jsdate.getTime() + 86400000).getDate() === 1;
}

export function getQueryTimeSpan() {
  return document.querySelector("body").getAttribute("timespan");
}

export function getYesterday(date, with_time) {
  // return the day before this date
  // console.log(date)
  // let yesterday = new Date().setDate( (date.getDate()-1) )
  let yesterday = new Date(date.valueOf() - 1000 * 60 * 60 * 24);

  if (with_time) {
    return new Date(yesterday);
  } else {
    return dateNoTime(yesterday);
  }
}

export function getToday() {
  let date = new Date();

  // its still "today" if we're before the next dayStartTime
  if (date.getTime() < date.setHours(window.ui.dayStartTime)) {
    date = new Date(date.setDate(date.getDate() - 1));
  }
  return dateNoTime(date);
}
export function addMins(date, minutes) {
  return new Date(date.getTime() + minutes * 60000);
}
export function isAfterMidnight(date) {
  // receives JS date obj
  // console.log(date)
}
export function is_this_date_today(date) {
  return dateNoTime(date).getTime() == dateNoTime(window.viewQuery.today).getTime();
}
export function compareTwoDatesExcludingTime(date1, date2) {
  date1 = new Date(date1);
  date2 = new Date(date2);

  date1 = Date.UTC(date1.getFullYear(), date1.getMonth(), date1.getDate());
  date2 = Date.UTC(date2.getFullYear(), date2.getMonth(), date2.getDate());

  date1 = Math.floor(Math.abs(date1) / 1000 / 60 / 60 / 24);
  date2 = Math.floor(Math.abs(date2) / 1000 / 60 / 60 / 24);

  return date1 >= date2;
}
export function getWeekNumber(d) {
  // from https://stackoverflow.com/a/6117889
  d = new Date(d);
  // Copy date so don't modify original
  d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
  // Set to nearest Thursday: current date + 4 - current day number
  // Make Sunday's day number 7
  d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
  // Get first day of year
  let yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
  // Calculate full weeks to nearest Thursday
  let weekNo = Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
  // Return array with week number
  return [`Week ${weekNo}`, weekNo];
}

export function getWeekNum(d) {
  // from https://stackoverflow.com/a/6117889

  // Copy date so don't modify original
  d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
  // Set to nearest Thursday: current date + 4 - current day number
  // Make Sunday's day number 7
  d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
  // Get first day of year
  let yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
  // Calculate full weeks to nearest Thursday
  let weekNo = Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
  // Return array with week number
  return weekNo;
}

export function calculateMinutesBetweenTwoTimes(time1, time2) {
  if (time1 === 0 || time2 === 0) {
    return 0;
  }

  if (time1 == null || time1 == undefined || time1 == "" || time2 == null || time2 == undefined || time2 == "") {
    return;
  }

  let time1HM = String(time1).match(window.regExes.splitTime);
  let time2HM = String(time2).match(window.regExes.splitTime);

  let differenceH = Math.abs(time1HM[0] - time2HM[0]);
  let differenceM = Math.abs(time1HM[1] - time2HM[1]);

  return differenceH * 60 + differenceM; // a single number, the total minutes
}

// Time and Date manipulation
// ======================================================

export function addTime(start_time, added_mins) {
  // make an add-time function. so i can add the duration of a goal to the current time,
  // and get back an end time. so itll predict when a goal would be done.
}

export function getDateStrings(dayObj) {
  const jsDateObj = new Date(dayObj);
  return {
    date: jsDateObj.getDate(),
    day: jsDateObj.getDay(),
    month: jsDateObj.getMonth(),
    week: getWeekNumber(jsDateObj)[1],
    dayName: window.ui.dayNames[jsDateObj.getDay()],
    dayNameShort: window.ui.dayNamesShort[jsDateObj.getDay()],
    moName: window.ui.monthNames[jsDateObj.getMonth()],
    moNameShort: window.ui.monthNamesShort[jsDateObj.getMonth()],
    year: jsDateObj.getFullYear(),
    unix: jsDateObj.getTime(),
    full: jsDateObj.toString(),
    full_date: jsDateObj.toDateString(),
  };
}

export function shiftTime(time, shift = { hours: 0, mins: 0 }) {
  // receives time string in xx:xx format
  // if either is blank, set it to 0
  shift.hours = shift.hours || 0;
  shift.mins = shift.mins || 0;

  console.log(shift.mins);
  time = time.match(window.regExes.timeNn);
  console.log(time);
  time[0] = parseInt(time[0]) + shift.hours || time[0];
  time[1] = parseInt(time[1]) + shift.mins || time[1];
  console.log(time);
  // return
}

export function setToTomorrow(date) {
  return new Date(new Date().setDate(date.getDate() - 1));
}

export function splitminsToHM(mins) {
  if (mins == 0) {
    return "";
  }

  // receives number mins, returns nn for Hours and nn for Mins
  let minsH = Math.floor(mins / 60);
  let minsM = Math.floor(mins % 60);
  if (minsH != 0) {
    minsH = `${minsH}h`;
  } else {
    minsH = "";
  }
  if (minsM != 0) {
    minsM = `${minsM}m`;
  } else {
    minsM = "";
  }
  return `${minsH} ${minsM}`;
}

export function minsToHM(duration) {
  if (isNaN(duration)) {
    return "";
  }

  let durationH = Math.floor(duration / 60);
  let durationM = Math.floor(duration % 60);

  if (durationH != 0) {
    durationH += "h";
  } else {
    durationH = "";
  }
  if (durationM != 0) {
    durationM += "m";
  } else {
    durationM = "";
  }

  if (durationH == "" && durationM == "") {
    return 0;
  } else if (durationH == undefined || durationM == undefined) {
    return "";
  } else if (durationH == "") {
    return `${durationM}`;
  } else if (durationM == "") {
    return `${durationH}`;
  } else {
    return `${durationH} ${durationM}`;
  }
}

export function sortDatesAscending(arrayOfDateObjects) {
  return arrayOfDateObjects.sort((date1, date2) => new Date(date1).getTime() - new Date(date2).getTime());
}

export function dateNoTime(date) {
  return new Date(new Date(date).setHours(0, 0, 0, 0));
}

Date.prototype.noTime = function (date) {
  return new Date(new Date(date).setHours(0, 0, 0, 0));
};

export function timeNoDate(date) {
  let endTimeH = String(date.getHours()).padStart(2, "0");
  let endTimeM = String(date.getMinutes()).padStart(2, "0");
  return `${endTimeH}:${endTimeM}`;
}

export function daysBetweenTwoDates(date1, date2) {
  // from https://stackoverflow.com/questions/2627473/how-to-calculate-the-number-of-days-between-two-dates

  const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
  const firstDate = dateNoTime(date1);
  const secondDate = dateNoTime(date2);
  const diffDays = Math.round(Math.abs((firstDate - secondDate) / oneDay));
  return diffDays;
}

export function isWeekday(day) {
  if (day == undefined) {
    console.warn("day is undefined");
    return "";
  }
  // returns 1 for weekday and 0 for weekend
  if (day.getDay() === 0 || day.getDay() === 6)
    return 0; // false weekend
  else {
    return 1; // true weekday
  }
}

export function countWeekdaysAndWeekends(dates) {
  // receives an array of JS date objects
  let number_of_weekdays = 0;
  let number_of_weekends = 0;
  for (let d = 0; d < dates.length; d++) {
    let date = new Date(dates[d]);
    if (date.getDay() === 0 || date.getDay() === 6) {
      number_of_weekends++;
    } else {
      number_of_weekdays++;
    }
  }
  return {
    weekdays: number_of_weekdays,
    weekends: number_of_weekends,
  };
}

export function monthWrap(monthNum) {
  if (monthNum < 1) {
    monthNum += 12;
  }
  return monthNum;
}

// Date Formatting

export function timeFormatter(x) {
  // receives ["9:15"] or ["9:15", "10:40"]. pads 0 to make 9 become 09.
  if (x == null) {
    return;
  }
  let newTime = x;
  for (let z = 0; z < newTime.length; z++) {
    let nnArray = newTime[z].match(window.regExes.timeNn);
    for (let y = 0; y < nnArray.length; y++) {
      nnArray[y] = nnArray[y].padStart(2, "0");
    }
    newTime[z] = `${nnArray[0]}:${nnArray[1]}`;
  }
  if (newTime.length < 2) {
    newTime.push("");
  }
  return newTime;
}

export function dateFormatter(dateObj, format_string) {
  if (format_string == "md") {
    return `${window.ui.monthNamesShort[new Date(dateObj).getMonth()]} ${new Date(dateObj).getDate()}`;
  }
}

export function dateFormatterJStoYYYYMMDD(dateObject) {
  // receives a normal JS Date object, outputs a string in YYYY/MM/DD format.
  let time = new Date(dateObject);
  let year = time.getFullYear();
  let month = String(time.getMonth() + 1).padStart(2, "0");
  let day = String(time.getDate()).padStart(2, "0");
  if (!Object.is(year, NaN) && !Object.is(month, NaN) && !Object.is(day, NaN)) {
    return `${year}/${month}/${day}`;
  } else {
    return undefined;
  }
}

export function dateFormatterYYYYMMDDtoJS(date) {
  if (date != undefined) {
    let datePieces = String(date).match(/\d{1,4}/g);
    let d = new Date();
    d.setFullYear(datePieces[0], datePieces[1] - 1, datePieces[2]);
    return d;
  }
}

export function dateFormatterWDMY(dateObject) {
  // receives an array normal JS Date object, ouputs a string in format:
  // Week 27: Fri 9th (July 2021)
  // console.warn(dateObject)

  let displayDate = new Date(dateObject[0]);
  let week = getWeekNumber(new Date(displayDate))[0];
  let week_string_num = String(getWeekNumber(new Date(displayDate))[1]).padStart(2, "0");
  let day = window.ui.dayNamesShort[displayDate.getDay()];
  let date = displayDate.getDate();
  let date_string_num = String(date).padStart(2, "0");
  let month = displayDate.getMonth() + 1;
  let month_string_num = String(month).padStart(2, "0");
  let month_name = window.ui.monthNamesShort[displayDate.getMonth()];
  let year = displayDate.getFullYear();

  let link_day = `obsidian://open?vault=MainVault&file=Journal/${year}-${month_string_num}-${date_string_num}`;
  let link_week = `obsidian://open?vault=MainVault&file=Journal/${year}-${month_string_num}-W${week_string_num}`;
  let link_month = `obsidian://open?vault=MainVault&file=Journal/${year}-${month_string_num}`;

  if (dateObject.length == 1) {
    return `<a href="${link_week}">${week}</a> — <a href="${link_day}">${day} ${date}</a> <a href="${link_month}">${month_name} ${year}</a>`;
    // return `${week} — ${month_name} ${year}`;
    // return `${week}: ${day} ${date} (${month_name} ${year})`
  } else {
    let first = new Date(dateObject[0]);
    let last = new Date(dateObject[dateObject.length - 1]);
    let week = getWeekNumber(new Date(dateObject[0]))[0];
    let day1 = window.ui.dayNamesShort[first.getDay()];
    let day2 = window.ui.dayNamesShort[last.getDay()];
    let date1 = first.getDate();
    let date2 = last.getDate();
    let month_name1 = window.ui.monthNamesShort[first.getMonth()];
    let month_name2 = window.ui.monthNamesShort[last.getMonth()];
    let month_string_num1 = String(first.getMonth() + 1).padStart(2, "0");
    let month_string_num2 = String(last.getMonth() + 1).padStart(2, "0");
    let link_month1 = `obsidian://open?vault=MainVault&file=Journal/${year}-${month_string_num1}`;
    let link_month2 = `obsidian://open?vault=MainVault&file=Journal/${year}-${month_string_num2}`;

    year = first.getFullYear();

    if (dateObject.length > 60) {
      return `${year}`;
    } else if (month_name1 != month_name2) {
      return `<a href="${link_week}">${week}</a> — <a href="${link_month1}">${month_name1}</a>/<a href="${link_month2}">${month_name2}</a> ${year}`;
    } else if (dateObject.length > 7) {
      let weeks = [];
      for (let x = 0; x < dateObject.length; x += 7) {
        let y = getWeekNumber(new Date(dateObject[x]))[1];
        let link_week = `obsidian://open?vault=MainVault&file=Journal/${year}-${month_string_num}-W${y}`;
        y = String(` <a href="${link_week}">${y}</a>`);
        weeks.push(y);
      }
      return `Weeks ${weeks}: — <a href="${link_month}">${month_name1} ${year}</a>`;
    } else {
      return `<a href="${link_week}">${week}</a> — <a href="${link_month}">${month_name1} ${year}</a>`;
    }

    // return `${week}: ${day1} ${date1} - ${day2} ${date2} (${month} ${year})`;
  }
}

export function displayFirstDate(listOfDays) {
  let date = new Date(listOfDays[listOfDays.length - 1][0]);
  return `${dateFormatterJStoYYYYMMDD(date)}`;
}

export function secsToMins(time) {
  let m = parseInt(time / 60);
  let s = parseInt(((time / 60) % 1) * 60);
  let mins = m ? `${m}<unit>m</unit>` : "";
  let secs = s ? `${s}<unit>s</unit>` : "";
  return `${mins} ${secs}`;
}

export function _getHour(entry) {
  return parseInt(entry.start.match(/\d\d/));
}

export function _getMins(entry) {
  return parseInt(String(entry.start.match(/:\d\d/)).replace(":", ""));
}
